import React from 'react'

export const EmptyStateIcon = () => (
  <svg width="104" height="84" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M26.167 62.666c1.463 0 2.69-.495 3.68-1.485.991-.99 1.486-2.217 1.486-3.681s-.495-2.691-1.485-3.681c-.99-.99-2.217-1.486-3.681-1.486s-2.691.495-3.682 1.486c-.99.99-1.485 2.217-1.485 3.68 0 1.465.495 2.692 1.485 3.682.99.99 2.218 1.486 3.682 1.486zM21 47.166h10.333V21.334H21v25.834zM41.667 57.5H83V47.166H41.667V57.5zm0-20.667H83V26.5H41.667v10.333zM.333 83.333V.667h103.334v82.666H.333zM10.667 73h82.666V11H10.667v62z"
      fill="#E3E3E3"
    />
  </svg>
)
